module.exports = __webpack_public_path__ + "img/ic_x_round.de9a601f.svg";